import { EntityType } from 'types/entityType';
import { FRAMES_PAGE_URL, LINKED_ASSETS_PAGE_URL } from 'utils/defaults';

export const getEntityPageUrl = (entityType: EntityType) => {
  switch (entityType) {
    case EntityType.FRAME:
      return FRAMES_PAGE_URL;
    case EntityType.LINKED_ASSET:
      return LINKED_ASSETS_PAGE_URL;
    default:
      return '';
  }
};
